import React from 'react'
import './style.css'

export const Loader = () => {
    return (
        <span className="loader"></span>
    )
}
